import Grid from '@mui/material/Grid'
import Card from '@mui/material/Card'
import Box from '@mui/material/Box'
import NotificationsTableBasic from '../../views/table/data-grid/NotificationsTableBasic'

const Notifications = () => {
  return (
    <Grid container spacing={6}>
      <Box component={Grid} item xs={12}>
        <Card>
          <NotificationsTableBasic />
        </Card>
      </Box>
    </Grid>
  )
}

export default Notifications
